module.exports = __webpack_public_path__ + "media/images/icon__infoBox@2x-dfd6d346b741d3760b108a30b63a9e6c.png";